import React from 'react'

export default function Star({ filled=1, size=14 }) {
	const id = `star-fill-${filled}`
	return (
		<svg width={size} viewBox="0 0 14 13" version="1.1">
			{( filled > 0 && filled < 1 ) && (
				<defs>
					<mask id={id} fill="white">
						<rect
							x="0"
							y="0"
							width={`${filled * 100}%`}
							height="100%"
							fill="white"
						/>
					</mask>
				</defs>
			)}
			<use xlinkHref="#star" fill={( filled >= 1 ? '#44474D' : '#E0E2E6' )} />
			{( filled > 0 && filled < 1 ) && (
				<use xlinkHref="#star" fill="#44474D" mask={`url(#${id})`} />
			)}
		</svg>
	)
}

export function Def() {
	return (
		<div style={{ display: 'none' }}>
			<svg viewBox="0 0 14 13" version="1.1">
				<defs>
					<path
						// eslint-disable-next-line max-len
						d="M7.25760632,0.21934114 L9.05529334,3.60662039 C9.1169067,3.72276306 9.23607215,3.80323656 9.37387782,3.82189428 L13.3936031,4.36506622 C13.7406512,4.41193647 13.8792205,4.80855819 13.6280809,5.03622752 L10.7193748,7.67284036 C10.619648,7.76325604 10.5741756,7.8934727 10.5977101,8.02113925 L11.2843433,11.744096 C11.343631,12.0655381 10.9808238,12.3107031 10.6703965,12.1589235 L7.07505721,10.4011924 C6.95179577,10.340926 6.80454851,10.340926 6.68125236,10.4011924 L3.08591303,12.1589235 C2.77548581,12.3107031 2.41267856,12.0655381 2.47196624,11.744096 L3.15863415,8.02113925 C3.18216872,7.8934727 3.13666161,7.76325604 3.03693474,7.67284036 L0.128263327,5.03622752 C-0.122910924,4.80855819 0.0156931089,4.41193647 0.362775936,4.36506622 L4.38246646,3.82189428 C4.52027212,3.80323656 4.63943757,3.72276306 4.70105093,3.60662039 L6.49873796,0.21934114 C6.65393421,-0.0731137133 7.10241007,-0.0731137133 7.25760632,0.21934114"
						id="star"
					/>
				</defs>
			</svg>
		</div>
	)
}
